import React from 'react';
import { IPaymentExpired } from '@components/Sura/PaymentExpired/types';
import { observer } from 'mobx-react';
import { Typography } from '@material-ui/core';
import useStore from '@hooks/useStore';
import useStyles from '@components/Sura/PaymentExpired/styles';
import GEAR from '@assets/images/logo-gear.svg';

const PaymentExpired: React.FC<IPaymentExpired> = () => {
  const { ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });

  return (
    <div className={css.card}>
      <div>
        <Typography className={css.labelSorry}>¡Lo sentimos!</Typography>
        <Typography className={css.labelDescrip}>
          La liga de pago ha caducado. <br /> Puede generar una nueva liga desde el portal
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://www.segurossura.com.mx"
            className={css.link}
          >
            {' '}
            www.segurossura.com.mx
          </a>{' '}
          o contáctenos: <br /> Teléfono: 55 58723 7946 <br /> Horario: Lunes a viernes de 8:00 a
          18:00 horas
        </Typography>
        <Typography className={css.labelSURA}>Seguros SURA #AsegurateDeVivir</Typography>
      </div>
      <img src={GEAR} className={css.img} />
    </div>
  );
};

export default observer(PaymentExpired);
